export default "__VITE_ASSET__baHSELbb__"